import React, { FC, memo } from 'react';

import Popup from '@components/common/Modal/ModalWrapper/Popup';
import ManageLiquidity from '@components/vaults/ManageLiquidity';

import { ManageLiquidityModalProps } from '@app-types/common/modal.types';

import useStyles from './styles.module';

const ManageLiquidityModal: FC<ManageLiquidityModalProps> = ({
  vaultInfo,
  vault,
  onCancel,
  defaultV3Farm,
}) => {
  const { classes } = useStyles();

  return (
    <Popup title="Manage Liquidity" classNameModal={classes.modal}>
      <ManageLiquidity
        vault={vault}
        vaultInfo={vaultInfo}
        defaultV3Farm={defaultV3Farm}
        onCancel={onCancel}
      />
    </Popup>
  );
};

export default memo(ManageLiquidityModal);
